import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/chevron-down-icon.svg'
import _imports_1 from '@/assets/icons/trash-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-679d01a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "accordion",
  id: "accordionExample"
}
const _hoisted_2 = { class: "accordion-item" }
const _hoisted_3 = { class: "accordion-header-wrapper d-flex justify-content-between align-items-center" }
const _hoisted_4 = {
  class: "accordion-header",
  id: "internalUsers"
}
const _hoisted_5 = { class: "title-accordion" }
const _hoisted_6 = { class: "accordion-body" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "trash-icon"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, [
          _createElementVNode("button", {
            class: _normalizeClass(["accordion-button d-flex flex-row-reverse", { 'collapsed': !_ctx.accordionOpened }]),
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleAccordion && _ctx.toggleAccordion(...args)))
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1),
            _createElementVNode("img", {
              src: _imports_0,
              alt: "chevron-down",
              class: _normalizeClass(["chevron-icon", { 'rotate-icon': _ctx.accordionOpened }])
            }, null, 2)
          ], 2)
        ]),
        _createElementVNode("div", {
          class: "action-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('headerAction')))
        }, _toDisplayString(_ctx.headerActionLabel), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["accordion-collapse collapse", { 'show': _ctx.accordionOpened }]),
        "aria-labelledby": "internalUsers",
        "data-bs-parent": "#accordionExample"
      }, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "accordion-row d-flex justify-content-between align-items-center ps-2",
              key: i,
              onClick: _withModifiers(($event: any) => (_ctx.$emit('selectItem',item)), ["stop"])
            }, [
              _createTextVNode(_toDisplayString(_ctx.getVariableName(item)) + " ", 1),
              (_ctx.trashIcon)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "cursor-pointer",
                    onClick: _withModifiers(($event: any) => (_ctx.$emit('trashAction', item)), ["stop"])
                  }, _hoisted_10, 8, _hoisted_8))
                : _createCommentVNode("", true)
            ], 8, _hoisted_7))
          }), 128))
        ])
      ], 2)
    ])
  ]))
}